import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import { ToastPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import router from "./router";
import store from "./store";
import VSelect from "vue-select";
import "./directives/is-able-directive.js";
import VueMonthlyPicker from 'vue-monthly-picker'
import eventBus from "./components/upload-file/eventBus.js";

Vue.use(ToastPlugin);
Vue.use(VueCompositionAPI);
Vue.use(BootstrapVue);
Vue.component("v-select", VSelect);
Vue.config.productionTip = false;
Vue.component("VueMonthlyPicker", VueMonthlyPicker);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

window.functionToCallFromApp = function (jsonSerializedFiles) {   
  eventBus.$emit("attachFilesOnForm", jsonSerializedFiles);
};